import { Modal } from "bootstrap";
import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";
import { toast } from "react-toastify";

const B2BLostLeadModal = forwardRef(
    ({ leadDetails, getLeadData }, ref) => {

        const modalRef = useRef(null);
        const bsModal = useRef(null);

        const mainStatus = "statusLost";

        // ================= MODAL TOGGLE =================
        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {
                    bsModal.current = new Modal(modalRef.current);
                }

                bsModal.current.show();
            },

            close() {
                bsModal.current?.hide();
            },

        }));

        // ================= CONFIRM LOST =================
        const handleConfirmLost = async () => {

            try {

                const res =
                    await b2bleadService.updateLostStatus(
                        leadDetails?.id,
                        mainStatus
                    );

                if (res?.data?.status) {

                    toast.success(
                        res?.data?.message ||
                        "Lead status updated successfully"
                    );

                }

                getLeadData?.();

                bsModal.current?.hide();

            } catch (err) {

                toast.error(
                    err?.response?.data?.message ||
                    "Something went wrong"
                );

                console.log(err);

            }

        };

        return (

            <div
                className="modal"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background: "rgba(15,23,42,0.55)",
                    backdropFilter: "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 overflow-hidden">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white position-relative"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div>
                                <h5 className="mb-1 fw-bold">
                                    Mark Lead as Lost
                                </h5>

                                <p className="mb-0 small opacity-75">
                                    Lead status confirmation
                                </p>
                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={() =>
                                    bsModal.current?.hide()
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* BODY */}
                        <div className="modal-body px-4 py-4">

                            <div
                                className="rounded-4 p-4 text-center"
                                style={{
                                    background: "#fef2f2",
                                    border: "1px solid #fecaca",
                                }}
                            >

                                <div
                                    className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                                    style={{
                                        width: "70px",
                                        height: "70px",
                                        background: "#dc2626",
                                        color: "#fff",
                                        fontSize: "28px",
                                    }}
                                >

                                    <i className="fa fa-times"></i>

                                </div>

                                <h5 className="fw-bold text-dark mb-2">
                                    Change Lead Status to Lost?
                                </h5>

                                <p
                                    className="mb-0"
                                    style={{
                                        color: "#6b7280",
                                        fontSize: "14px",
                                        lineHeight: "1.7",
                                    }}
                                >

                                    Are you sure you want to mark this lead as
                                    <span className="fw-bold text-danger">
                                        {" "}Lost
                                    </span>
                                    ?

                                </p>

                            </div>

                        </div>

                        {/* FOOTER */}
                        <div className="modal-footer border-0 px-4 pb-4">

                            <button
                                type="button"
                                className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                onClick={() =>
                                    bsModal.current?.hide()
                                }
                            >

                                Cancel

                            </button>

                            <button
                                type="button"
                                className="btn btn-sm btn-danger rounded-pill px-4 fw-semibold shadow-sm"
                                onClick={handleConfirmLost}
                            >

                                Yes, Mark Lost

                            </button>

                        </div>

                    </div>

                </div>

            </div>
        );
    }
);

export default B2BLostLeadModal;